import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    makeStyles,
    IconButton,
    InputBase,
    Button,
    Box,
    CircularProgress,
    Tooltip,
    Typography,
} from '@material-ui/core';

import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import DeleteIcon from '@material-ui/icons/Delete';
import PublishIcon from '@material-ui/icons/Publish';
import ClearIcon from '@material-ui/icons/Clear';

import { downloadFile } from 'app/utils/forms/files';
import helpers from 'app/utils/helpers';
import filesEndpoint from 'app/api/services/filesEndpoint';
import { DOCUMENT_TYPES } from 'app/utils/constants';
import { injectIntl } from 'react-intl';
import { fixedDocumentName, validateFile } from 'app/utils/forms/validators/file';

import styles from './styles';
const useStyles = makeStyles(styles);

function DocumentField(props) {
    const classes = useStyles();

    const {
        intl,
        field,
        label,
        id,
        required,
        error,
        disabled,
        name,
        preffix,
        idFile,
        idGdoc,
        onChangeFile,
        onDeleteFile,
        uploading,
        setUpLoading,
        value,
        guest,
        onlyIcon,
    } = props;

    const [fileName, setFileName] = useState('');
    const [idFileUploaded, setIdFileUploaded] = useState(null);
    const [loading, setLoading] = useState(false);
    const [boExcluido, setBoExcluido] = useState(false);
    const dispatch = useDispatch();

    const [fieldName, setFieldName] = useState(() => {
        const name = field.name;
        if (name && name.indexOf('.') > 0) {
            return name.split('.').shift();
        }
        return name;
    });

    useEffect(() => {
        if (field.name) setFieldName(field.name);
    }, [field]);

    useEffect(() => {
        setFileName(value ? value : name);
    }, [name, value]);

    useEffect(() => {
        setIdFileUploaded(idFile);
    }, [idFile]);

    const deleteFile = () => {
        setFileName('');
        if (onDeleteFile) {
            onDeleteFile(idFileUploaded);
        }
        if (id) {
            const element = document.getElementById(id);
            if (element) element.value = null;
        }
        setBoExcluido(true);
    };

    const handleChange = ({ target: { name, files } }) => {
        if (setUpLoading) setUpLoading(true);
        setLoading(true);
        setFileName('Processando...');
        const reader = new FileReader();
        reader.onabort = () => console.log('file reading was aborted');
        reader.onerror = () => console.log('file reading has failed');
        reader.onload = async () => {
            let tempFileName = files[0].name;
            let newName = fixedDocumentName(tempFileName);
            let nameSplitted = newName.split('.');
            let ext = nameSplitted.pop();

            const valid = validateFile(files, intl);
            if (!valid) {
                setLoading(false);
                setFileName('');
                if (setUpLoading) setUpLoading(false);
                return;
            }

            const sendingData = new FormData();
            if (idFile) {
                sendingData.append('id', idFile);
            } else if (idFileUploaded) {
                sendingData.append('id', idFileUploaded);
            }

            const convertedFile = helpers.dataURItoBlob(reader.result);

            if (String(id).indexOf(DOCUMENT_TYPES.OTHERS) >= 0) {
                if (preffix && newName.indexOf(preffix) < 0) {
                    newName = `${preffix} - ${newName}`;
                }
                sendingData.append('filename', newName);
                sendingData.append('file', convertedFile, newName);
            } else {
                let tempName = name;
                if (preffix && tempName?.indexOf(preffix) < 0) {
                    tempName = `${preffix} - ${tempName}`;
                }
                sendingData.append('filename', `${tempName}.${ext}`);
                sendingData.append('file', convertedFile, tempName);
            }

            try {
                await sendingFile(sendingData);
            } catch (e) {
                console.error(e);
                setLoading(false);
                setFileName('');
                if (setUpLoading) setUpLoading(false);
                if (id) {
                    const element = document.getElementById(id);
                    if (element) element.value = null;
                }
                return;
            }

            setLoading(false);
        };
        reader.readAsDataURL(files[0]);
    };

    const sendingFile = async (data) => {
        let response;
        if (guest) {
            response = await filesEndpoint.uploadGuestFile(data);
        } else {
            response = await filesEndpoint.uploadFile(data);
        }
        if (response?.status === 200 && response?.data) {
            const responseFile = { ...response.data };
            setBoExcluido(false);
            setFileName(response.data.name);
            setIdFileUploaded(response.data.id);
            responseFile.boExcluido = false;
            responseFile.boAlterado = true;
            if (idGdoc) {
                responseFile.idGdoc = idGdoc;
            }
            if (onChangeFile) onChangeFile(responseFile);
        } else {
            throw String('Erro ao enviar arquivo');
        }
    };

    return (
        <div className={classes.field}>
            {!onlyIcon && label && (
                <label className={classes.documentLabel}>
                    {label} {required ? '*' : ''}
                </label>
            )}
            <input id={id} name={`${fieldName}`} onChange={handleChange} type="file" style={{ display: 'none' }} />
            <div className={`${!onlyIcon ? classes.root : ''}`}>
                {loading && <CircularProgress size={16} className={classes.loading} />}
                {!loading && (
                    <>
                        {(boExcluido || (!disabled && !idFileUploaded)) && uploading && (
                            <>
                                {!onlyIcon ? (
                                    <Button
                                        className={classes.btnCarregarDisabled}
                                        disabled
                                        component="span"
                                        size="small">
                                        Carregar
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        className={classes.btnSigleAction}
                                        component="span"
                                        size="small"
                                        disabled>
                                        <PublishIcon fontSize="inherit" />
                                    </Button>
                                )}
                            </>
                        )}

                        {(boExcluido || (!disabled && !idFileUploaded)) && !uploading && (
                            <label htmlFor={id}>
                                {!onlyIcon ? (
                                    <Button className={classes.btnCarregar} component="span" size="small">
                                        Carregar
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        className={classes.btnSigleAction}
                                        component="span"
                                        size="small">
                                        <PublishIcon fontSize="inherit" />
                                    </Button>
                                )}
                            </label>
                        )}

                        {!onlyIcon && (
                            <>
                                <InputBase value={fileName ? fileName : ' '} disabled={disabled} />

                                {!boExcluido && idFileUploaded && (
                                    <div className={!disabled ? classes.containerButtons : ''}>
                                        <IconButton
                                            color="primary"
                                            className={classes.iconDocument}
                                            size="small"
                                            onClick={async () =>
                                                await downloadFile({ idFile: idFileUploaded, dispatch })
                                            }>
                                            <InsertDriveFileIcon className={classes.icon} />
                                        </IconButton>

                                        {!disabled && (
                                            <IconButton
                                                className={classes.iconDelete}
                                                size="small"
                                                onClick={() => deleteFile()}>
                                                <DeleteIcon className={classes.icon} />
                                            </IconButton>
                                        )}
                                    </div>
                                )}
                            </>
                        )}

                        {onlyIcon && (
                            <>
                                {!boExcluido && !disabled && idFileUploaded && (
                                    <div>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className={classes.btnSigleAction}
                                            size="small"
                                            onClick={() => downloadFile({ idFile: idFileUploaded, dispatch })}>
                                            <InsertDriveFileIcon fontSize="inherit" />
                                        </Button>
                                        {!value?.hasRevisionOk && (
                                            <Tooltip
                                                className={classes.tooltip}
                                                title={
                                                    <Typography color="inherit">
                                                        Trocar arquivo atual:{' '}
                                                        {value?.fileName ? value?.fileName : fileName}
                                                    </Typography>
                                                }>
                                                <Button
                                                    variant="contained"
                                                    color="default"
                                                    className={classes.btnSigleAction}
                                                    size="small"
                                                    onClick={() => deleteFile()}>
                                                    <ClearIcon className={classes.icon} />
                                                </Button>
                                            </Tooltip>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
            {error && (
                <Box className={classes.error} color="error.main">
                    Campo obrigatório
                </Box>
            )}
        </div>
    );
}

export default injectIntl(DocumentField);
